/* tslint:disable */
/* eslint-disable */
/**
 * Linked Events information API
 * Linked Events provides categorized data on events and places using JSON-LD format. Events can be searched by date and location. Location can be exact address or larger area such as neighbourhood or borough JSON-LD format is streamlined using include mechanism. API users can request that certain fields are included directly into the result, instead of being hyperlinks to objects. Several fields are multilingual. These are implemented as object with each language variant as property. In this specification each multilingual field has (fi,sv,en) property triplet as example.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    InlineResponse2002,
    InlineResponse2002FromJSON,
    InlineResponse2002ToJSON,
    InlineResponse2003,
    InlineResponse2003FromJSON,
    InlineResponse2003ToJSON,
    InlineResponse2004,
    InlineResponse2004FromJSON,
    InlineResponse2004ToJSON,
    InlineResponse2005,
    InlineResponse2005FromJSON,
    InlineResponse2005ToJSON,
    Keyword,
    KeywordFromJSON,
    KeywordToJSON,
    KeywordSet,
    KeywordSetFromJSON,
    KeywordSetToJSON,
    Organization,
    OrganizationFromJSON,
    OrganizationToJSON,
    Place,
    PlaceFromJSON,
    PlaceToJSON,
    PostKeywordSet,
    PostKeywordSetFromJSON,
    PostKeywordSetToJSON,
} from '../models';

export interface KeywordCreateRequest {
    keywordObject?: Keyword;
}

export interface KeywordDeleteRequest {
    id: string;
}

export interface KeywordListRequest {
    page?: number;
    pageSize?: number;
    include?: Array<string>;
    showAllKeywords?: boolean;
    dataSource?: string;
    text?: string;
    sort?: string;
}

export interface KeywordRetrieveRequest {
    id: string;
}

export interface KeywordSetListRequest {
    page?: number;
    pageSize?: number;
    include?: Array<string>;
}

export interface KeywordSetRetrieveRequest {
    id: string;
}

export interface KeywordSetUpdateRequest {
    id: string;
    keywordSetObject?: PostKeywordSet;
}

export interface KeywordUpdateRequest {
    id: string;
    keywordObject?: Keyword;
}

export interface OrganizationListRequest {
    page?: number;
    pageSize?: number;
    child?: string;
    parent?: string;
}

export interface OrganizationRetrieveRequest {
    id: string;
}

export interface PlaceCreateRequest {
    placeObject?: Place;
}

export interface PlaceDeleteRequest {
    id: string;
}

export interface PlaceListRequest {
    page?: number;
    pageSize?: number;
    showAllPlaces?: boolean;
    division?: string;
    dataSource?: string;
    text?: string;
    sort?: string;
}

export interface PlaceRetrieveRequest {
    id: string;
}

export interface PlaceUpdateRequest {
    id: string;
    placeObject?: Place;
}

/**
 * 
 */
export class FilterApi extends runtime.BaseAPI {

    /**
     * Endpoint for creating new keywords
     * Creates new keyword
     */
    async keywordCreateRaw(requestParameters: KeywordCreateRequest): Promise<runtime.ApiResponse<Keyword>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/keyword/`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: KeywordToJSON(requestParameters.keywordObject),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => KeywordFromJSON(jsonValue));
    }

    /**
     * Endpoint for creating new keywords
     * Creates new keyword
     */
    async keywordCreate(requestParameters: KeywordCreateRequest): Promise<Keyword> {
        const response = await this.keywordCreateRaw(requestParameters);
        return await response.value();
    }

    /**
     * Deletes a keyword
     * Delete a keyword
     */
    async keywordDeleteRaw(requestParameters: KeywordDeleteRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling keywordDelete.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/keyword/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Deletes a keyword
     * Delete a keyword
     */
    async keywordDelete(requestParameters: KeywordDeleteRequest): Promise<void> {
        await this.keywordDeleteRaw(requestParameters);
    }

    /**
     * <h2 id=\"using-keyword-endpoint\">Using the keyword endpoint</h2> <p>Here, categories for events are listed. Events in each category can be found at the <code>event</code> endpoint using the query parameter <code>keyword</code>. The common keywords used in all events originate from the <a href=\"https://finto.fi/yso/en/\">general Finnish ontology (yso)</a>, hence the format <code>yso:p4354</code>. Default ordering is decreasing order by the number of events found.</p> <h4 id=\"keyword-text\">Keyword text</h4> <p>To find keywords that contain a specific string, use the query parameter <code>text</code>.</p> <p>Example:</p> <pre><code>keyword/?text=lapset </code></pre> <p><a href=\"?text=lapset\" title=\"json\">See the result</a></p> <h4 id=\"keyword-source\">Keyword source</h4> <p>Will restrict keywords to a specific data source.</p> <p>Example:</p> <pre><code>keyword/?data_source=yso </code></pre> <p><a href=\"?data_source=yso\" title=\"json\">See the result</a></p> <h4 id=\"ordering\">Ordering</h4> <p>Default ordering is decreasing order by the number of events found. You may also order results by <code>name</code>. <p>Example:</p> <pre><code>keyword/?sort=name </code></pre> <p><a href=\"?sort=name\" title=\"json\">See the result</a></p> <h4 id=\"showing-all-keyword\">Showing all keywords</h4> <p>By default, only those keywords which have listed events are displayed. You may display keywords with zero <code>n_events</code> with the     query parameter <code>show_all_keywords</code>.</p> 
     * Returns a list of keywords used for describing events
     */
    async keywordListRaw(requestParameters: KeywordListRequest): Promise<runtime.ApiResponse<InlineResponse2002>> {
        const queryParameters: any = {};

        if (requestParameters.page !== undefined) {
            queryParameters['page'] = requestParameters.page;
        }

        if (requestParameters.pageSize !== undefined) {
            queryParameters['page_size'] = requestParameters.pageSize;
        }

        if (requestParameters.include) {
            queryParameters['include'] = requestParameters.include.join(runtime.COLLECTION_FORMATS["csv"]);
        }

        if (requestParameters.showAllKeywords !== undefined) {
            queryParameters['show_all_keywords'] = requestParameters.showAllKeywords;
        }

        if (requestParameters.dataSource !== undefined) {
            queryParameters['data_source'] = requestParameters.dataSource;
        }

        if (requestParameters.text !== undefined) {
            queryParameters['text'] = requestParameters.text;
        }

        if (requestParameters.sort !== undefined) {
            queryParameters['sort'] = requestParameters.sort;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/keyword/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => InlineResponse2002FromJSON(jsonValue));
    }

    /**
     * <h2 id=\"using-keyword-endpoint\">Using the keyword endpoint</h2> <p>Here, categories for events are listed. Events in each category can be found at the <code>event</code> endpoint using the query parameter <code>keyword</code>. The common keywords used in all events originate from the <a href=\"https://finto.fi/yso/en/\">general Finnish ontology (yso)</a>, hence the format <code>yso:p4354</code>. Default ordering is decreasing order by the number of events found.</p> <h4 id=\"keyword-text\">Keyword text</h4> <p>To find keywords that contain a specific string, use the query parameter <code>text</code>.</p> <p>Example:</p> <pre><code>keyword/?text=lapset </code></pre> <p><a href=\"?text=lapset\" title=\"json\">See the result</a></p> <h4 id=\"keyword-source\">Keyword source</h4> <p>Will restrict keywords to a specific data source.</p> <p>Example:</p> <pre><code>keyword/?data_source=yso </code></pre> <p><a href=\"?data_source=yso\" title=\"json\">See the result</a></p> <h4 id=\"ordering\">Ordering</h4> <p>Default ordering is decreasing order by the number of events found. You may also order results by <code>name</code>. <p>Example:</p> <pre><code>keyword/?sort=name </code></pre> <p><a href=\"?sort=name\" title=\"json\">See the result</a></p> <h4 id=\"showing-all-keyword\">Showing all keywords</h4> <p>By default, only those keywords which have listed events are displayed. You may display keywords with zero <code>n_events</code> with the     query parameter <code>show_all_keywords</code>.</p> 
     * Returns a list of keywords used for describing events
     */
    async keywordList(requestParameters: KeywordListRequest): Promise<InlineResponse2002> {
        const response = await this.keywordListRaw(requestParameters);
        return await response.value();
    }

    /**
     * Return information for single keyword
     */
    async keywordRetrieveRaw(requestParameters: KeywordRetrieveRequest): Promise<runtime.ApiResponse<Keyword>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling keywordRetrieve.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/keyword/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => KeywordFromJSON(jsonValue));
    }

    /**
     * Return information for single keyword
     */
    async keywordRetrieve(requestParameters: KeywordRetrieveRequest): Promise<Keyword> {
        const response = await this.keywordRetrieveRaw(requestParameters);
        return await response.value();
    }

    /**
     * Unlike other endpoints, keyword_sets do not support filtering. It is expected that the full result set will remain small enough. Recommended keyword_sets are <code>helsinki:topics</code> for general categorization and <code>helsinki:audiences</code> for target grouping.
     * Return as list of keyword_sets for grouping keywords
     */
    async keywordSetListRaw(requestParameters: KeywordSetListRequest): Promise<runtime.ApiResponse<InlineResponse2003>> {
        const queryParameters: any = {};

        if (requestParameters.page !== undefined) {
            queryParameters['page'] = requestParameters.page;
        }

        if (requestParameters.pageSize !== undefined) {
            queryParameters['page_size'] = requestParameters.pageSize;
        }

        if (requestParameters.include) {
            queryParameters['include'] = requestParameters.include.join(runtime.COLLECTION_FORMATS["csv"]);
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/keyword_set/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => InlineResponse2003FromJSON(jsonValue));
    }

    /**
     * Unlike other endpoints, keyword_sets do not support filtering. It is expected that the full result set will remain small enough. Recommended keyword_sets are <code>helsinki:topics</code> for general categorization and <code>helsinki:audiences</code> for target grouping.
     * Return as list of keyword_sets for grouping keywords
     */
    async keywordSetList(requestParameters: KeywordSetListRequest): Promise<InlineResponse2003> {
        const response = await this.keywordSetListRaw(requestParameters);
        return await response.value();
    }

    /**
     * Return information about single keyword_set
     */
    async keywordSetRetrieveRaw(requestParameters: KeywordSetRetrieveRequest): Promise<runtime.ApiResponse<KeywordSet>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling keywordSetRetrieve.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/keyword_set/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => KeywordSetFromJSON(jsonValue));
    }

    /**
     * Return information about single keyword_set
     */
    async keywordSetRetrieve(requestParameters: KeywordSetRetrieveRequest): Promise<KeywordSet> {
        const response = await this.keywordSetRetrieveRaw(requestParameters);
        return await response.value();
    }

    /**
     * Update single keyword_set
     */
    async keywordSetUpdateRaw(requestParameters: KeywordSetUpdateRequest): Promise<runtime.ApiResponse<KeywordSet>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling keywordSetUpdate.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/keyword_set/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: PostKeywordSetToJSON(requestParameters.keywordSetObject),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => KeywordSetFromJSON(jsonValue));
    }

    /**
     * Update single keyword_set
     */
    async keywordSetUpdate(requestParameters: KeywordSetUpdateRequest): Promise<KeywordSet> {
        const response = await this.keywordSetUpdateRaw(requestParameters);
        return await response.value();
    }

    /**
     * Keywords can be updated if the user has appropriate access permissions.
     * Update a keyword
     */
    async keywordUpdateRaw(requestParameters: KeywordUpdateRequest): Promise<runtime.ApiResponse<Keyword>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling keywordUpdate.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/keyword/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: KeywordToJSON(requestParameters.keywordObject),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => KeywordFromJSON(jsonValue));
    }

    /**
     * Keywords can be updated if the user has appropriate access permissions.
     * Update a keyword
     */
    async keywordUpdate(requestParameters: KeywordUpdateRequest): Promise<Keyword> {
        const response = await this.keywordUpdateRaw(requestParameters);
        return await response.value();
    }

    /**
     * <h2 id=\"using-organization-endpoint\">Using the organization endpoint</h2> <p>Here, the event publisher organizations are listed. Events published by each organization     can be found at the <code>event</code> endpoint using the query parameter <code>publisher</code>.</p> 
     * Returns a list of organizations that publish events
     */
    async organizationListRaw(requestParameters: OrganizationListRequest): Promise<runtime.ApiResponse<InlineResponse2004>> {
        const queryParameters: any = {};

        if (requestParameters.page !== undefined) {
            queryParameters['page'] = requestParameters.page;
        }

        if (requestParameters.pageSize !== undefined) {
            queryParameters['page_size'] = requestParameters.pageSize;
        }

        if (requestParameters.child !== undefined) {
            queryParameters['child'] = requestParameters.child;
        }

        if (requestParameters.parent !== undefined) {
            queryParameters['parent'] = requestParameters.parent;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/organization/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => InlineResponse2004FromJSON(jsonValue));
    }

    /**
     * <h2 id=\"using-organization-endpoint\">Using the organization endpoint</h2> <p>Here, the event publisher organizations are listed. Events published by each organization     can be found at the <code>event</code> endpoint using the query parameter <code>publisher</code>.</p> 
     * Returns a list of organizations that publish events
     */
    async organizationList(requestParameters: OrganizationListRequest): Promise<InlineResponse2004> {
        const response = await this.organizationListRaw(requestParameters);
        return await response.value();
    }

    /**
     * Return information for single organization
     */
    async organizationRetrieveRaw(requestParameters: OrganizationRetrieveRequest): Promise<runtime.ApiResponse<Organization>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling organizationRetrieve.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/organization/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => OrganizationFromJSON(jsonValue));
    }

    /**
     * Return information for single organization
     */
    async organizationRetrieve(requestParameters: OrganizationRetrieveRequest): Promise<Organization> {
        const response = await this.organizationRetrieveRaw(requestParameters);
        return await response.value();
    }

    /**
     * Endpoint for creating new places
     * Creates new place
     */
    async placeCreateRaw(requestParameters: PlaceCreateRequest): Promise<runtime.ApiResponse<Place>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/place/`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PlaceToJSON(requestParameters.placeObject),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => PlaceFromJSON(jsonValue));
    }

    /**
     * Endpoint for creating new places
     * Creates new place
     */
    async placeCreate(requestParameters: PlaceCreateRequest): Promise<Place> {
        const response = await this.placeCreateRaw(requestParameters);
        return await response.value();
    }

    /**
     * Deletes a place
     * Delete a place
     */
    async placeDeleteRaw(requestParameters: PlaceDeleteRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling placeDelete.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/place/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Deletes a place
     * Delete a place
     */
    async placeDelete(requestParameters: PlaceDeleteRequest): Promise<void> {
        await this.placeDeleteRaw(requestParameters);
    }

    /**
     * <h2 id=\"using-place-endpoint\">Using the place endpoint</h2> <p>Here, locations for events are listed. Events in each location can be found at the <code>event</code> endpoint using the query parameter <code>location</code>. Most locations     originate from the <a href=\"https://servicemap.hel.fi\">Helsinki service point registry (tprek)</a>, hence the id format <code>tprek:28473</code>. An easy way to locate service points is         to browse our <a href=\"https://servicemap.hel.fi\">Service Map</a>, which uses the same location ids, e.g. <code>servicemap.hel.fi/unit/28473</code>. Default ordering is decreasing order by the number of events found.</p> <h4 id=\"place-text\">Place text</h4> <p>To find places that contain a specific string, use the query parameter <code>text</code>.</p> <p>Example:</p> <pre><code>place/?text=tuomiokirkko </code></pre> <p><a href=\"?text=tuomiokirkko\" title=\"json\">See the result</a></p> <h4 id=\"district\">District</h4> <p>To restrict the retrieved places to city district(s), use the query parameter <code>division</code>, separating values by commas if you wish to query for several divisions.</p> <p>City of Helsinki neighborhoods (kaupunginosa), districts (peruspiiri) and subdistricts (osa-alue) are supported.     <a href=\"http://kartta.hel.fi/?setlanguage=en&e=25498873&n=6674660&r=16&w=***&l=Karttasarja%2Ckaupunginosat%2Cosaalueet_WFS%2Cperuspiiri_WFS&o=100%2C100%2C100%2C100&swtab=kaikki\">         Check the divisions on the Helsinki map service.</a> </p> <p>You may query either by specific OCD division type <code>peruspiiri:malmi</code>, or by division name <code>malmi</code>. The latter query checks all divisions with the name, regardless of division type.</p> <p>Example:</p> <pre><code>place/?division=malmi </code></pre> <p><a href=\"?division=malmi\" title=\"json\">See the result</a></p> <h4 id=\"ordering\">Ordering</h4> <p>Default ordering is decreasing order by the number of events found.     You may also order results by <code>name</code>, <code>street_address</code> or <code>postal_code</code>.     For example:</p> <pre><code>place/?sort=name </code></pre> <p><a href=\"?sort=name\" title=\"json\">See the result</a></p>       <h4 id=\"place-source\">Place source</h4> <p>Will restrict places to a specific data source.</p> <p>Example:</p> <pre><code>place/?data_source=tprek </code></pre> <p><a href=\"?data_source=tprek\" title=\"json\">See the result</a></p> <h4 id=\"showing-all-places\">Showing all places</h4> <p>By default, only those locations which have listed events are displayed. You may display locations with zero <code>n_events</code> with the     query parameter <code>show_all_places</code>.</p> 
     * Returns list of places used for describing events
     */
    async placeListRaw(requestParameters: PlaceListRequest): Promise<runtime.ApiResponse<InlineResponse2005>> {
        const queryParameters: any = {};

        if (requestParameters.page !== undefined) {
            queryParameters['page'] = requestParameters.page;
        }

        if (requestParameters.pageSize !== undefined) {
            queryParameters['page_size'] = requestParameters.pageSize;
        }

        if (requestParameters.showAllPlaces !== undefined) {
            queryParameters['show_all_places'] = requestParameters.showAllPlaces;
        }

        if (requestParameters.division !== undefined) {
            queryParameters['division'] = requestParameters.division;
        }

        if (requestParameters.dataSource !== undefined) {
            queryParameters['data_source'] = requestParameters.dataSource;
        }

        if (requestParameters.text !== undefined) {
            queryParameters['text'] = requestParameters.text;
        }

        if (requestParameters.sort !== undefined) {
            queryParameters['sort'] = requestParameters.sort;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/place/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => InlineResponse2005FromJSON(jsonValue));
    }

    /**
     * <h2 id=\"using-place-endpoint\">Using the place endpoint</h2> <p>Here, locations for events are listed. Events in each location can be found at the <code>event</code> endpoint using the query parameter <code>location</code>. Most locations     originate from the <a href=\"https://servicemap.hel.fi\">Helsinki service point registry (tprek)</a>, hence the id format <code>tprek:28473</code>. An easy way to locate service points is         to browse our <a href=\"https://servicemap.hel.fi\">Service Map</a>, which uses the same location ids, e.g. <code>servicemap.hel.fi/unit/28473</code>. Default ordering is decreasing order by the number of events found.</p> <h4 id=\"place-text\">Place text</h4> <p>To find places that contain a specific string, use the query parameter <code>text</code>.</p> <p>Example:</p> <pre><code>place/?text=tuomiokirkko </code></pre> <p><a href=\"?text=tuomiokirkko\" title=\"json\">See the result</a></p> <h4 id=\"district\">District</h4> <p>To restrict the retrieved places to city district(s), use the query parameter <code>division</code>, separating values by commas if you wish to query for several divisions.</p> <p>City of Helsinki neighborhoods (kaupunginosa), districts (peruspiiri) and subdistricts (osa-alue) are supported.     <a href=\"http://kartta.hel.fi/?setlanguage=en&e=25498873&n=6674660&r=16&w=***&l=Karttasarja%2Ckaupunginosat%2Cosaalueet_WFS%2Cperuspiiri_WFS&o=100%2C100%2C100%2C100&swtab=kaikki\">         Check the divisions on the Helsinki map service.</a> </p> <p>You may query either by specific OCD division type <code>peruspiiri:malmi</code>, or by division name <code>malmi</code>. The latter query checks all divisions with the name, regardless of division type.</p> <p>Example:</p> <pre><code>place/?division=malmi </code></pre> <p><a href=\"?division=malmi\" title=\"json\">See the result</a></p> <h4 id=\"ordering\">Ordering</h4> <p>Default ordering is decreasing order by the number of events found.     You may also order results by <code>name</code>, <code>street_address</code> or <code>postal_code</code>.     For example:</p> <pre><code>place/?sort=name </code></pre> <p><a href=\"?sort=name\" title=\"json\">See the result</a></p>       <h4 id=\"place-source\">Place source</h4> <p>Will restrict places to a specific data source.</p> <p>Example:</p> <pre><code>place/?data_source=tprek </code></pre> <p><a href=\"?data_source=tprek\" title=\"json\">See the result</a></p> <h4 id=\"showing-all-places\">Showing all places</h4> <p>By default, only those locations which have listed events are displayed. You may display locations with zero <code>n_events</code> with the     query parameter <code>show_all_places</code>.</p> 
     * Returns list of places used for describing events
     */
    async placeList(requestParameters: PlaceListRequest): Promise<InlineResponse2005> {
        const response = await this.placeListRaw(requestParameters);
        return await response.value();
    }

    /**
     * Return information for single place
     */
    async placeRetrieveRaw(requestParameters: PlaceRetrieveRequest): Promise<runtime.ApiResponse<Place>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling placeRetrieve.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/place/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => PlaceFromJSON(jsonValue));
    }

    /**
     * Return information for single place
     */
    async placeRetrieve(requestParameters: PlaceRetrieveRequest): Promise<Place> {
        const response = await this.placeRetrieveRaw(requestParameters);
        return await response.value();
    }

    /**
     * Place can be updated if the user has appropriate access permissions.
     * Update a place
     */
    async placeUpdateRaw(requestParameters: PlaceUpdateRequest): Promise<runtime.ApiResponse<Place>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling placeUpdate.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/place/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: PlaceToJSON(requestParameters.placeObject),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => PlaceFromJSON(jsonValue));
    }

    /**
     * Place can be updated if the user has appropriate access permissions.
     * Update a place
     */
    async placeUpdate(requestParameters: PlaceUpdateRequest): Promise<Place> {
        const response = await this.placeUpdateRaw(requestParameters);
        return await response.value();
    }

}
